/* ==========================================================================
   PMP — Declencheur de la barre collante article (2026-09-01)

   Charge APRES pmp-clarity-fixes.js. Ce fichier ne fait qu'une chose :
   garantir que la barre .pmp-cf-bar finit par s'afficher, quel que soit
   l'environnement de rendu.

   Pourquoi ce fichier existe : sur ce theme le scroll est porte par <html>
   et window.scrollY reste bloque a 0 ; un declencheur base sur scrollY est
   donc inoperant. IntersectionObserver n'est pas garanti non plus (il ne se
   declenche pas dans certains contextes de rendu).

   Quatre mecanismes independants, du plus fin au plus grossier. Le premier
   qui detecte fait foi ; aucun ne peut masquer la barre une fois qu'elle a
   ete montree par le filet de securite temporel.
     1. IntersectionObserver sur la sentinelle ;
     2. evenement scroll capture au niveau document (capture: true), ce qui
        remonte le scroll de n'importe quel conteneur ;
     3. poll de position toutes les 400 ms pendant 90 s ;
     4. FILET FINAL : au bout de 12 s passees sur l'article, la barre est
        affichee sans condition et verrouillee. La duree moyenne de session
        relevee dans Clarity est de 100 s : 12 s correspond a un lecteur
        reellement engage, et cela garantit que le CTA est vu meme si toute
        la logique de position echoue.
   ========================================================================== */

(function () {
  'use strict';

  if (!/\/blogs\/[^\/]+\/[^\/]+/.test(window.location.pathname)) return;

  var bar = null;
  var sentinel = null;
  var locked = false;   /* une fois verrouille, on n'essaie plus de masquer */
  var attempts = 0;

  function show() {
    if (bar) bar.setAttribute('data-visible', 'true');
  }

  function apply() {
    if (locked || !bar || !sentinel || !sentinel.isConnected) return;
    /* La barre apparait des que la sentinelle (placee juste apres l'encart
       produit) est passee au-dessus de la zone visible. */
    if (sentinel.getBoundingClientRect().top < 0) {
      show();
    } else {
      bar.setAttribute('data-visible', 'false');
    }
  }

  function wire() {
    bar = document.querySelector('.pmp-cf-bar');
    sentinel = document.querySelector('[data-pmp-cf-sentinel]');
    if (!bar) return false;

    /* 1. IntersectionObserver */
    try {
      if (sentinel && 'IntersectionObserver' in window) {
        new IntersectionObserver(apply, { threshold: 0 }).observe(sentinel);
      }
    } catch (e) {}

    /* 2. Scroll capture au niveau document : remonte le scroll de tout
          conteneur, y compris <html> et les zones a overflow interne. */
    document.addEventListener('scroll', apply, { capture: true, passive: true });
    window.addEventListener('resize', apply, { passive: true });

    /* 3. Poll de position, borne dans le temps. */
    var ticks = 0;
    var pollId = setInterval(function () {
      apply();
      if (locked || ++ticks > 225) clearInterval(pollId); /* 90 s max */
    }, 400);

    /* 4. Filet final : affichage inconditionnel apres 12 s. */
    setTimeout(function () {
      if (!bar || !bar.isConnected) return;   /* barre fermee par le visiteur */
      locked = true;
      show();
    }, 12000);

    apply();
    return true;
  }

  /* La barre est creee apres un fetch produit : on attend son apparition,
     au maximum 10 s. */
  function boot() {
    if (wire()) return;
    if (++attempts > 50) return;
    setTimeout(boot, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
